module.exports = __webpack_public_path__ + "img/bannerImg.15ac6cd8.png";